<div class="bulkImportContainer">
  <div class="bulkImportHeader">
    <h2>Import Lessons</h2>
    <a class="needHelpLink" [href]="bulkImportWikiUrl" target="_blank">Need Help?</a>
  </div>

  <div class="templates">
    <div class="downloadTemplateRow">
      <button
        type="button"
        class="btn btn-primary downloadBtn"
        (click)="downloadTemplateV2()"
      >
        Download Template
      </button>
    </div>

    <input
      #fileInputNew
      class="form-control"
      type="file"
      hidden
      accept=".xlsx"
      (change)="onFileSelected($event)"
    />

    <div class="importGrid" [formGroup]="importForm">
      <div class="infoContainer">
        <h5>Import Name</h5>
        <mat-form-field appearance="outline" class="width-100">
          <input
            id="fileNickname"
            matInput
            type="text"
            formControlName="fileNickname"
          />
          <mat-error>Please fill out this field</mat-error>
        </mat-form-field>
        <h5>Import Description</h5>
        <mat-form-field appearance="outline" class="width-100">
          <textarea
            id="bulkDescription"
            matInput
            formControlName="fileDescription"
          ></textarea>
          <mat-error>Please fill out this field</mat-error>
        </mat-form-field>
      </div>

      <div class="upload-lesson-border" [class.upload-lesson-border--error]="fileMissingError">
        <h6>
          Please note we ONLY accept .xlsx files utilizing one of our
          templates.
        </h6>
        <div class="uploadBtns">
          <button
            class="btn btn-primary chooseFileBtn"
            (click)="fileInputNew.click()"
          >
            select file
          </button>
          @if (fileMissingError) {
          <span class="fieldErrorText">Please select a file</span>
          } @if (fileName) {
          <mat-chip-listbox class="fileName">
            <mat-chip-option>
              <img
                src="../../../../../../assets/images/Excel.png"
                alt="Excel Icon"
                class="excelIcon"
              />
              {{ fileName }}
              <mat-icon class="matChipRemove" (click)="removeFile()"
                >close</mat-icon
              >
            </mat-chip-option>
          </mat-chip-listbox>
          }
        </div>

        @if (file && showDisclaimer) {
        <h6 class="disclaimerText">
          Lessons uploaded via bulk import will be placed in the 'draft'
          status
        </h6>
        } @if (!uploadInProgress && importCompleted) {
        <p class="successText">
          Bulk upload completed successfully. An e-mail notification will be
          sent when the submission is available in your ‘Actions’.
        </p>
        }
      </div>
    </div>

    <div class="uploadActionRow">
      <button
        [disabled]="uploadInProgress"
        (click)="uploadV2()"
        class="btn btn-primary uploadBtn"
      >
        upload
      </button>
      @if (uploadInProgress) {
      <div class="uploadSpinner">
        <mat-spinner diameter="55"></mat-spinner>
      </div>
      }
    </div>
  </div>
</div>
